export default __webpack_public_path__ + "images/0xde903e2712288a1da82942dddf2c20529565ac30.png";